import React from "react";
import { Link } from "react-router-dom";
import Logo from "../../../assets/images/logo-white.png";

const Footer = () => {
  return (
    <div className="footer_container">
      <div className="box_container">
        <div className="footer_wraper">
          <div className="footer_link_container">
            <div className="footer_link">
              <Link>Paramètres générales</Link>
            </div>
            <div className="footer_link">
              <Link>Politiques de confidentialité</Link>
            </div>
            <div className="footer_right">
              &copy; <span>Admission - Ecole229 {new Date().getFullYear()}</span>
            </div>
          </div>
          <div className="footer_logo">
            <img src={Logo} alt="ecole229_logo" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
